import { useMutation, useQueryClient } from "@tanstack/react-query";
import { UserProfileDto, UserRole } from "@green0meter/api-client";

import { DOMAIN_REVENUE_AND_EXPENSES } from "../domain";

import { revenueAndExpensesApi } from "@api/services";
import { roleGuard } from "@api";

export const ACTION_DELETE_REVENUE_AND_EXPENSE = "DELETE_REVENUE_AND_EXPENSE";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

const deleteRevenueAndExpense = async (
  revenueAndExpensesId: string,
): Promise<void> => {
  const response =
    await revenueAndExpensesApi.revenueAndExpensesControllerDeleteRevenueAndExpense(
      revenueAndExpensesId,
    );

  return response.data;
};

export const useDeleteRevenueAndExpense = (
  user: UserProfileDto | null,
): {
  deleteRevenueAndExpense: (revenueAndExpensesId: string) => void;
  deleteRevenueAndExpenseEnabled: boolean;
  isSuccessDeleteRevenueAndExpense: boolean;
  isPendingDeleteRevenueAndExpense: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutate, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_REVENUE_AND_EXPENSES, ACTION_DELETE_REVENUE_AND_EXPENSE],
    mutationFn: enabled ? deleteRevenueAndExpense : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [DOMAIN_REVENUE_AND_EXPENSES] });
    },
  });

  return {
    deleteRevenueAndExpense: mutate,
    deleteRevenueAndExpenseEnabled: enabled,
    isSuccessDeleteRevenueAndExpense: isSuccess,
    isPendingDeleteRevenueAndExpense: isPending,
  };
};
